// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  HttpMethod,
  RestAuthType,
} from "./types";

export default {
  endpointId: __t.u64(),
  name: __t.string(),
  description: __t.string(),
  url: __t.string(),
  get method() {
    return HttpMethod;
  },
  headersJson: __t.string(),
  queryParamsJson: __t.string(),
  pathParamsJson: __t.string(),
  bodyTemplate: __t.string(),
  get authType() {
    return RestAuthType;
  },
  enabled: __t.bool(),
  specId: __t.u64(),
};
